import { type ReactNode } from 'react';
import { Gray300, Gray700, Violet500 } from '@zep-us/zus';

// Figma 스펙: neutral 0% → violet 20% → disabled 50%, 이후 disabled 평탄 유지.
// gradient-text-shine 유틸은 200% 타일을 반복시키므로 양 끝 색이 같아야 이음새가
// 없다 — 마지막 85→100% 구간만 start로 되돌려 seam(밝은 세로선)을 제거한다.
const AI_BUILDER_SHINE_GRADIENT = `linear-gradient(90deg, ${Gray700} 0%, ${Violet500} 20%, ${Gray300} 50%, ${Gray300} 85%, ${Gray700} 100%)`;

/** AI 진행 중 텍스트에 쓰는 shine 애니메이션. 텍스트 전용 — 아이콘은 형제로 배치한다. */
export const AiBuilderShineText = ({
  children
}: {
  children: ReactNode;
}) => <span className="gradient-text-shine" style={{
  backgroundImage: AI_BUILDER_SHINE_GRADIENT
}} data-sentry-component="AiBuilderShineText" data-sentry-source-file="AiBuilderShineText.tsx">
    {children}
  </span>;